/*
  Instant variant price update (no waiting for the server).
  Data: <script data-vc-variants> rendered in sections/main-product.liquid (all variant prices load with the page).
  On variant pick it finds the variant in the browser, updates the main price + Save badge
  right away, and fires "vc:variant-change" so the payment box and sticky bar update too.
  Dawn still refreshes the section afterwards with the same values.
*/
(function () {
  function makeMoney(fmtStr) {
    return function (cents) {
      cents = Number(cents) || 0;
      var key = (fmtStr.match(/\{\{\s*(\w+)\s*\}\}/) || [])[1] || 'amount';
      var dec = key.indexOf('no_decimals') > -1 ? 0 : 2;
      var comma = key.indexOf('comma_separator') > -1;
      var parts = (cents / 100).toFixed(dec).split('.');
      var whole = parts[0].replace(/\B(?=(\d{3})+(?!\d))/g, comma ? '.' : ',');
      var value = whole + (parts[1] ? (comma ? ',' : '.') + parts[1] : '');
      return fmtStr ? fmtStr.replace(/\{\{\s*\w+\s*\}\}/, value) : 'Rs.' + value;
    };
  }

  function init(dataEl) {
    if (dataEl.dataset.ready) return;
    dataEl.dataset.ready = '1';
    var data;
    try { data = JSON.parse(dataEl.textContent); } catch (e) { return; }
    var money = makeMoney(data.money || '');
    var section = data.section;
    var lastId = null;

    function groups(picker) {
      return picker.querySelectorAll('fieldset, .product-form__input--dropdown');
    }

    /* Selected option values; "override" lets us read the option being pressed before the browser checks it */
    function selectedOptions(picker, override) {
      var values = [];
      groups(picker).forEach(function (group) {
        if (override && group.contains(override)) { values.push(override.value); return; }
        var checked = group.querySelector('input[type="radio"]:checked');
        var select = group.querySelector('select');
        if (checked) values.push(checked.value);
        else if (select) values.push(select.value);
      });
      return values;
    }

    function findVariant(values) {
      for (var i = 0; i < data.variants.length; i++) {
        var v = data.variants[i];
        var ok = v.options.length === values.length;
        for (var j = 0; ok && j < values.length; j++) if (v.options[j] !== values[j]) ok = false;
        if (ok) return v;
      }
      return null;
    }

    function setText(root, selector, text) {
      root.querySelectorAll(selector).forEach(function (n) { n.textContent = text; });
    }

    function updateMainPrice(v) {
      var wrap = document.getElementById('price-' + section);
      var price = wrap && wrap.querySelector('.price');
      if (!price) return;
      var onSale = v.compare > v.price;
      price.classList.toggle('price--on-sale', onSale);
      price.classList.toggle('price--sold-out', !v.available);
      setText(price, '.price__regular .price-item--regular', money(v.price));
      setText(price, '.price__sale .price-item--sale', money(v.price));
      setText(price, '.price__sale s.price-item--regular, .price__sale .price-item--regular', money(onSale ? v.compare : v.price));
      price.querySelectorAll('.price__badge-save').forEach(function (b) {
        if (!onSale) return;
        b.textContent = b.dataset.mode === 'percent'
          ? Math.round((v.compare - v.price) * 100 / v.compare) + '% OFF'
          : 'Save ' + money(v.compare - v.price);
      });
    }

    function apply(picker, override) {
      var v = findVariant(selectedOptions(picker, override));
      if (!v || v.id === lastId) return;
      lastId = v.id;
      updateMainPrice(v);
      document.dispatchEvent(new CustomEvent('vc:variant-change', { detail: { variant: v } }));
    }

    /* Capture phase: runs right after the tap, before Dawn starts its server request */
    document.addEventListener('change', function (e) {
      var picker = e.target.closest && e.target.closest('variant-selects, variant-radios');
      if (picker) apply(picker, null);
    }, true);
  }

  function initAll() { document.querySelectorAll('script[data-vc-variants]').forEach(init); }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', initAll);
  else initAll();
  document.addEventListener('shopify:section:load', initAll);
})();
